import { formatLearningDate } from './formatLearningDate';

function normalizeScoreFields(results, metaData, questionCount) {
  const correctCount = Number(
    results.total_score
    ?? results.correct_score
    ?? metaData.total_score
    ?? 0,
  );

  let totalQuestions = Number(
    results.survey_total_score
    ?? results.total_questions
    ?? metaData.survey_total_score
    ?? 0,
  );

  if (!totalQuestions && questionCount > 0) {
    totalQuestions = questionCount;
  }

  if (!totalQuestions && correctCount > 0) {
    totalQuestions = correctCount;
  }

  return { correctCount, totalQuestions };
}

/** Maps `survey/answerSurvey` response to L&D outcome screen fields. */
export function mapLearningSubmitResponse(response, { questionCount } = {}) {
  const body = response?.data;

  if (!body || body.success === false) {
    return null;
  }

  const results = body.results || body.data?.results || body.data || {};
  const metaData = results.metaData || results.metadata || {};
  const { correctCount, totalQuestions } = normalizeScoreFields(
    results,
    metaData,
    questionCount,
  );

  const scorePercent = Number(
    metaData.score_percentage ?? results.score_percentage ?? 0,
  );
  const resultStatus = metaData.result_status ?? results.result_status ?? null;
  const completedAtRaw = results.updatedAt ?? results.updated_at ?? null;
  const responseId = results._id ?? results.response_id ?? metaData.response_id ?? null;

  return {
    scorePercent,
    correctCount,
    totalQuestions,
    resultStatus,
    responseId: responseId ? String(responseId) : '',
    completedAt: completedAtRaw
      ? formatLearningDate(new Date(completedAtRaw))
      : formatLearningDate(new Date()),
  };
}

/** e.g. "100% (2/2)" or "100%" when total is unknown. */
export function formatLearningScoreSummary({ scorePercent, correctCount, totalQuestions }) {
  if (totalQuestions > 0) {
    return `${scorePercent}% (${correctCount}/${totalQuestions})`;
  }

  return `${scorePercent}%`;
}

export function resolveQuizPassed({ resultStatus, scorePercent }, passMarkPercent) {
  if (resultStatus) {
    const status = String(resultStatus).toLowerCase();

    if (['pass', 'passed', 'success'].includes(status)) {
      return true;
    }

    if (['fail', 'failed', 'locked'].includes(status)) {
      return false;
    }
  }

  return scorePercent >= passMarkPercent;
}

export function resolveQuizLocked({ resultStatus }, { attemptNumber, maxAttempts }) {
  if (resultStatus && String(resultStatus).toLowerCase() === 'locked') {
    return true;
  }

  return attemptNumber >= maxAttempts;
}
